var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head',[_c('title',[_vm._v(_vm._s(_vm.title)+" | Warnemünder Bau GmbH")])]),_vm._v(" "),_c('Layout',[_c('AdList',{attrs:{"ads":_vm.ads,"active-ad":_vm.activeAd}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }